export const fonts = {
  family: {
    heading: 'Medel',
    bodyBold: 'OpenSans-Bold',
    bodyMedium: 'OpenSans-Medium',
    bodyRegular: 'OpenSans-Regular',
    bodyLight: 'OpenSans-Light',
  },
};
